function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Icon from '../icon';
import InputBase from '../input/InputBase';

var SearchBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchBar, _PureComponent);

  function SearchBar(props) {
    var _this;

    _classCallCheck(this, SearchBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchBar).call(this, props));
    _this.cancelRef = void 0;
    _this.cancelOuterWidth = void 0;
    _this.inputRef = void 0;
    _this.state = {
      focus: false,
      value: props.defaultValue || props.value || '',
      isOnComposition: false
    };
    return _this;
  }

  _createClass(SearchBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculatePositon(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          cancelText = _this$props.cancelText,
          showCancel = _this$props.showCancel,
          locale = _this$props.locale; // 若改变了取消文字的内容或者placeholder的内容需要重新计算位置

      if (cancelText !== prevProps.cancelText || showCancel !== prevProps.showCancel || locale.cancelText !== prevProps.locale.cancelText) {
        this.calculatePositon(this.props);
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var onFocus = this.props.onFocus;
      this.setState({
        focus: true
      });
      this.focusAnim();
      onFocus && onFocus();
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      var onChange = this.props.onChange;
      var isOnComposition = this.state.isOnComposition;
      this.setState({
        value: value
      });

      if (!isOnComposition && onChange) {
        onChange(value);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var _this2 = this;

      var onBlur = this.props.onBlur;
      var _this$state = this.state,
          value = _this$state.value,
          focus = _this$state.focus;
      this.setState({
        focus: false
      }, function () {
        !value && _this2.blurAnim();
        focus && onBlur && onBlur();
      });
    }
  }, {
    key: "onClear",
    value: function onClear() {
      var _this3 = this;

      var _this$props2 = this.props,
          onClear = _this$props2.onClear,
          onChange = _this$props2.onChange;
      this.setState({
        value: '',
        isOnComposition: false
      }, function () {
        _this3.focus();
      });
      onClear && onClear('');
      onChange && onChange('');
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      var _this4 = this;

      var onCancel = this.props.onCancel;
      this.setState({
        value: '',
        isOnComposition: false
      }, function () {
        _this4.onBlur();
      });
      onCancel && onCancel();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      var onSubmit = this.props.onSubmit;
      var value = this.state.value;
      e.preventDefault();
      this.inputRef.blur();
      onSubmit && onSubmit(value);
    }
  }, {
    key: "handleComposition",
    value: function handleComposition(e) {
      if (e.type === 'compositionstart') {
        this.setState({
          isOnComposition: true
        });
      }

      if (e.type === 'compositionend') {
        // composition is end
        this.setState({
          isOnComposition: false
        });
        var onChange = this.props.onChange;
        var value = e.target.value;
        onChange && onChange(value);
      }
    } // 初始化搜索提示文字的位置

  }, {
    key: "calculatePositon",
    value: function calculatePositon(props) {
      var showCancel = props.showCancel;
      var value = this.state.value;
      var ml = parseInt(window.getComputedStyle(this.cancelRef, '')['margin-left'].split('px')[0], 10);
      this.cancelOuterWidth = Math.ceil(ml + this.cancelRef.getBoundingClientRect().width);

      if (!showCancel) {
        this.cancelRef.style.cssText = "margin-right: -".concat(this.cancelOuterWidth, "px;");
      } else {
        this.cancelRef.style.cssText = 'margin-right: 0px;';
      }

      if (value) {
        this.focusAnim();
      }
    }
  }, {
    key: "focusAnim",
    value: function focusAnim() {
      this.cancelRef.style.cssText = 'margin-right: 0px;';
      this.cancelRef.className += ' animation-ease';
    }
  }, {
    key: "blurAnim",
    value: function blurAnim() {
      var showCancel = this.props.showCancel;

      if (!showCancel) {
        this.cancelRef.style.cssText = "margin-right: -".concat(this.cancelOuterWidth, "px;");
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.inputRef.focus();
    }
  }, {
    key: "renderCancel",
    value: function renderCancel() {
      var _this5 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          cancelText = _this$props3.cancelText,
          locale = _this$props3.locale;
      return React.createElement("div", {
        className: "".concat(prefixCls, "__cancel"),
        ref: function ref(cancelRef) {
          _this5.cancelRef = cancelRef;
        },
        onClick: function onClick() {
          _this5.onCancel();
        }
      }, cancelText || locale.cancelText);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this6 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          className = _this$props4.className,
          shape = _this$props4.shape,
          placeholder = _this$props4.placeholder,
          disabled = _this$props4.disabled,
          clearable = _this$props4.clearable,
          showCancel = _this$props4.showCancel,
          maxLength = _this$props4.maxLength,
          locale = _this$props4.locale;
      var _this$state2 = this.state,
          value = _this$state2.value,
          focus = _this$state2.focus;
      var cls = classnames(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--").concat(shape), !!shape), _defineProperty(_classnames, "".concat(prefixCls, "--focus"), !!(showCancel || focus || value && value.length > 0)), _classnames));
      return React.createElement("div", {
        className: cls
      }, React.createElement("form", {
        action: "#",
        className: "".concat(prefixCls, "__form"),
        onSubmit: function onSubmit(e) {
          _this6.onSubmit(e);
        }
      }, React.createElement("div", {
        className: "".concat(prefixCls, "__content")
      }, React.createElement(Icon, {
        type: "search",
        className: "".concat(prefixCls, "__icon")
      }), React.createElement("div", {
        className: "".concat(prefixCls, "__mock")
      }, React.createElement(InputBase, {
        className: "".concat(prefixCls, "__input"),
        type: "search",
        placeholder: placeholder || locale.placeholder,
        value: value,
        maxLength: maxLength,
        onFocus: function onFocus() {
          _this6.onFocus();
        },
        onCompositionStart: function onCompositionStart(e) {
          _this6.handleComposition(e);
        },
        onCompositionUpdate: function onCompositionUpdate(e) {
          _this6.handleComposition(e);
        },
        onCompositionEnd: function onCompositionEnd(e) {
          _this6.handleComposition(e);
        },
        onChange: function onChange(val) {
          _this6.onChange(val);
        },
        onBlur: function onBlur() {
          _this6.onBlur();
        },
        onClear: function onClear() {
          _this6.onClear();
        },
        disabled: disabled,
        clearable: clearable,
        ref: function ref(inputRef) {
          _this6.inputRef = inputRef;
        }
      }))), this.renderCancel()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ('value' in nextProps && nextProps.value !== state.preValue) {
        return {
          value: nextProps.value,
          preValue: nextProps.value
        };
      }

      return null;
    }
  }]);

  return SearchBar;
}(PureComponent);

SearchBar.defaultProps = {
  prefixCls: 'za-search-bar',
  shape: 'radius',
  disabled: false,
  showCancel: false,
  clearable: true
};
export { SearchBar as default };